var _excluded = ["disableAds"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useMemo } from 'react';
import { ListingType, ListingTypeByPageContext, ListingTypeName, TitanAdKey, TitanAdKeyCtypeValues } from '@domain-group/fe-allhomes-library';
import { AdProvider, PageType, Section } from '@domain-group/fe-co-allhomes-ads';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { jsx as ___EmotionJSX } from "@emotion/core";
var flattenLocality = locality => locality ? [locality, ...flattenLocality(locality.parent)] : [];
var getLocalityData = localities => {
  var localitySets = {
    DIVISION: new Set(),
    DISTRICT: new Set(),
    REGION: new Set(),
    POSTCODE: new Set()
  };
  var states = new Set();
  var types = new Set();
  var allLocalities = localities.flatMap(flattenLocality);
  allLocalities.forEach(item => {
    var _item$metaData, _item$metaData2, _localitySets$item$ty;
    if ((_item$metaData = item.metaData) !== null && _item$metaData !== void 0 && _item$metaData.state) {
      states.add(item.metaData.state);
    }
    if ((_item$metaData2 = item.metaData) !== null && _item$metaData2 !== void 0 && _item$metaData2.postcode) {
      localitySets.POSTCODE.add("".concat(item.metaData.postcode));
    }
    (_localitySets$item$ty = localitySets[item.type]) === null || _localitySets$item$ty === void 0 ? void 0 : _localitySets$item$ty.add(item.name);
  });
  localities.forEach(item => {
    if (item.type === 'SCHOOL') {
      types.add('school catchment');
    } else if (item.type === 'DIVISION') {
      types.add('suburb');
    } else {
      types.add(item.type.toLowerCase());
    }
  });
  return {
    divisions: [...localitySets.DIVISION],
    districts: [...localitySets.DISTRICT],
    regions: [...localitySets.REGION],
    postcodes: [...localitySets.POSTCODE],
    states: [...states],
    types: [...types]
  };
};
var getSection = _ref => {
  var listingType = _ref.listingType,
    isSold = _ref.isSold;
  if (isSold) {
    return Section.Sold;
  }
  if (listingType.isCommercial) {
    return Section.Commercial;
  }
  switch (listingType.name) {
    case ListingTypeName.DEVELOPMENTS_RESIDENTIAL:
      return Section.NewHomes;
    case ListingTypeName.SHARE_RESIDENTIAL:
    case ListingTypeName.RENTAL_RESIDENTIAL:
      return Section.Rent;
    default:
      return Section.Buy;
  }
};
var makeAdKeySafe = adKey => adKey ? adKey.replace(/'/g, '_').toLowerCase() : '';
var adKeyList = keys => keys.filter(key => key).map(makeAdKeySafe).join(',');
var adControlWrapper = BaseComponent => {
  var AdEnabledComponent = _ref2 => {
    var _ref2$disableAds = _ref2.disableAds,
      disableAds = _ref2$disableAds === void 0 ? false : _ref2$disableAds,
      props = _objectWithoutProperties(_ref2, _excluded);
    var _useAllhomesApi = useAllhomesApi(),
      getLogger = _useAllhomesApi.getLogger;
    var log = getLogger('fe-pa-allhomes-listing-search-results#adControlWrapper');
    log.debug('Rendering', {
      props
    });
    useEffect(() => {
      log.warn('Mounted');
      return () => {
        log.warn('Unmounted');
      };
    }, [log]);
    var listingTypeName = props.listingType,
      searchQuery = props.searchQuery,
      currentPage = props.currentPage;
    var listingType = ListingType[listingTypeName];
    var pageContext = listingType.pageContext ? ListingTypeByPageContext[listingType.pageContext] : undefined;
    var adKey = pageContext ? TitanAdKey[pageContext] : undefined;
    var searchString = searchQuery.toSearchUrl();
    var adTargeting = useMemo(() => {
      if (!(listingType.category && adKey)) {
        return undefined;
      }
      var localities = searchQuery.getLocalities();
      var locdata = getLocalityData(localities);
      return {
        config: {
          pageType: PageType.SearchResults,
          section: getSection({
            listingType,
            isSold: searchQuery.filters.isSold()
          })
        },
        data: {
          cat: adKey.cat2,
          cat1: adKey.cat,
          cat2: 'searchresults',
          ctype: TitanAdKeyCtypeValues.INDEX,
          locstate: adKeyList(locdata.states),
          locarea: adKeyList(locdata.districts),
          locregion: adKeyList(locdata.regions),
          locsuburb: adKeyList(locdata.divisions),
          locpostcode: adKeyList(locdata.postcodes),
          searchlocationcat: adKeyList(locdata.types)
        }
      };
    }, [searchString, adKey, listingType.category, currentPage]);
    return ___EmotionJSX(AdProvider, {
      disableAds: disableAds,
      targeting: adTargeting,
      key: currentPage
    }, ___EmotionJSX(BaseComponent, props));
  };
  return AdEnabledComponent;
};
export default adControlWrapper;